import { Box, Checkbox } from '@chakra-ui/react';
import {
    getBulkCheckboxLeft,
    RO_BULK_CHECKBOX_GUTTER,
} from '../../constants/pageLayout';

interface OrderSelectAllHeaderCheckboxProps {
    /** Padding token used to center the checkbox in the RO column gutter. */
    contentPlWithBulk: string;
    allPageSelected: boolean;
    isPageSelectionIndeterminate: boolean;
    onToggle: () => void;
    isDisabled?: boolean;
    ariaLabel?: string;
}

/**
 * Header select-all in the RO Number gutter (same slot as invoicing).
 * Hidden until the header is hovered or any page rows are selected.
 */
const OrderSelectAllHeaderCheckbox = ({
    contentPlWithBulk,
    allPageSelected,
    isPageSelectionIndeterminate,
    onToggle,
    isDisabled = false,
    ariaLabel = 'Select all on this page',
}: OrderSelectAllHeaderCheckboxProps) => {
    const isVisible = allPageSelected || isPageSelectionIndeterminate;

    return (
        <Box
            className="order-select-all-checkbox"
            position="absolute"
            left={getBulkCheckboxLeft(contentPlWithBulk)}
            top="50%"
            transform="translateY(-50%)"
            w={RO_BULK_CHECKBOX_GUTTER}
            display="flex"
            alignItems="center"
            justifyContent="center"
            opacity={isVisible ? 1 : 0}
            pointerEvents={isVisible ? 'auto' : 'none'}
            transition="opacity 150ms ease"
            onClick={(e) => e.stopPropagation()}
        >
            <Checkbox
                aria-label={ariaLabel}
                isChecked={allPageSelected}
                isIndeterminate={isPageSelectionIndeterminate}
                isDisabled={isDisabled}
                size="sm"
                colorScheme="blue"
                sx={{
                    '& .chakra-checkbox__control': {
                        width: '14px',
                        height: '14px',
                    },
                    '& .chakra-checkbox__icon': {
                        fontSize: '9px',
                    },
                }}
                onChange={() => onToggle()}
                onClick={(e) => e.stopPropagation()}
            />
        </Box>
    );
};

export default OrderSelectAllHeaderCheckbox;
